import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@cardboard-ui/react';
import React from 'react';

interface BaseErrorMessageProps {
  title?: string;
  description?: string;
}
interface ErrorMessageProps extends BaseErrorMessageProps {
  size?: 'md' | 'lg';
}

export const ErrorMessage = ({ size, ...props }: ErrorMessageProps) => {
  switch (size) {
    case 'lg':
      return <LargeErrorMessage {...props} />;
    default:
      return <MediumErrorMessage {...props} />;
  }
};

const MediumErrorMessage = ({ title, description }: BaseErrorMessageProps) => (
  <Alert status="error" variant="subtle" borderRadius="md">
    <AlertIcon />
    {title && <AlertTitle>{title}</AlertTitle>}
    {description && <AlertDescription>{description}</AlertDescription>}
  </Alert>
);

const LargeErrorMessage = ({ title, description }: BaseErrorMessageProps) => (
  <Alert
    status="error"
    variant="subtle"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    py={4}
    borderRadius="md"
  >
    <AlertIcon boxSize="40px" mr={0} mb={4} />
    {title && (
      <AlertTitle mb={1} fontSize="lg">
        {title}{' '}
      </AlertTitle>
    )}
    {description && (
      <AlertDescription maxWidth="sm">{description}</AlertDescription>
    )}
  </Alert>
);
